
import { Component, Getter, Prop, Vue } from 'bits/vue'

/**
 * This component handles the membership tier 4x1 - 2x2 grid.
 */

@Component({})
export default class OzMembershipTierGrid extends Vue {
  /**
   * Defines whether the grid should be expanded (4x1) or not (2x2).
   */
  @Prop({ default: true }) isExpanded!: boolean

  /**
   * Whether the tier corresponds to a school library.
   */
  @Prop({ default: false }) isSchoolLibrary!: boolean
}
